import Loadable from "@loadable/component";

const ErrorLayout = Loadable(
  () => import(/* webpackChunkName: "error_layout_component" */ "./errorLayout")
);

export default ErrorLayout;
